<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE ORIGEM DO CONTATO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12">
          <label ><small v-show="form.nome.required" class="text-danger">*</small> Origem:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite a Origem'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2 mb-3">
        <div class="col-md-6">
          <label for="permissionSelect"> Tipo de Quadro:</label>
          <v-select multiple v-model="form.tipoAcessoOrigem.value" :options="form.tipoAcessoOrigem.options"
            :reduce="option => option.value" class="w-100" label="name">
            <template v-slot:no-options>Nenhum tipo de quadro encontrado.</template>
          </v-select>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import OriginModel from '@/shared/models/configurations/originmodel.js'
import OriginForms from './origin-form.js'
import OriginRepository from '@/shared/http/repositories/configurations/origin.js'

export default {
  name: 'OriginAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: OriginModel,
      form: OriginForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      if (obj && obj.numero) {
        this.form.numero.value = parseInt(obj.numero)
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      this.data.nome = this.form.nome.value
      OriginRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.nome = this.form.nome.value
      OriginRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/origem/components/add/originadd.vue